import React from 'react';
import { sendAnalytics } from 'utils/analyticsUtils';
import {
    sendCustomClick
} from '../../../utils/SnowplowUtils';
import {
    buttonTypes,
    loginSubCategory,
    registerSubCategory
} from '../../../constants/SnowplowConst';



export const notifyRedirectToTicketWidget = () => {
    if (!window.parent) {
        return;
    }
    if (!window.parent.postMessage) {
        return;
    }
    window.parent.postMessage(
        { type: 'bzsdk.redirectToRegistration' },
        '*'
    );
};

const LoginPopover = ({
    analyticData={},
    onLoginClick,
    eventUrls: { registrationsUrl },
    setLoginV2OffsetTop,
    isWidget,
}) => {

    const handleLogin = (e) => {
        sendAnalytics('loginClick', analyticData);

        if (isWidget && window.self !== window.parent) {
            setLoginV2OffsetTop?.(e.pageY);
        }
        sendCustomClick(buttonTypes.login, loginSubCategory.loginTooltip, e.currentTarget);
        onLoginClick();
    };

    const handleRegister = (e) => {
        sendCustomClick(buttonTypes.register, registerSubCategory.loginPopover, e.currentTarget);
        notifyRedirectToTicketWidget();
    };

    return (
        <div>
            <div className="text">
                <span className="text-bold">You must be logged in to proceed</span>
            </div>
            <div className="popover-buttons margin-vertical-small">
                <a
                    className="btn btn-default custom-color color-1-background text-color-white navigate-to-login"
                    onClick={handleLogin}
                >
                    Login
                </a>
            </div>
            <div className="text">
                <a
                    className="navigate-to-buy"
                    target="_top"
                    onClick={handleRegister}
                    href={registrationsUrl}
                >
                    Register
                </a> to the event
            </div>
        </div>
    );
};


export default LoginPopover;
